import { parseDobToDate } from "./others";

export function formatDate(isoDate: string, format: 'default' | 'dmy' = 'dmy'): string {
  // Date-only strings (YYYY-MM-DD) parsed via `new Date(str)` are interpreted as
  // UTC midnight, which shifts the displayed day for users in negative UTC offsets
  // (e.g. "2025-05-06" displays as "May 5, 2025" in EST). Use the local-component
  // parser for date-only inputs; full ISO timestamps go through `new Date` as-is.
  const isDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(isoDate);
  const date = isDateOnly ? parseDobToDate(isoDate) : new Date(isoDate);
  if (!date || Number.isNaN(date.getTime())) return isoDate;

  if (format === 'default') {
    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "short",
      day: "numeric",
    };
    return date.toLocaleDateString("en-US", options);
  }

  // DD/MM/YYYY (UK display format used across the UW journey)
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}
